import { lazy, Suspense } from 'react';

// Import CSS - this will be bundled but loaded on demand
import 'react-toastify/dist/ReactToastify.css';

// Lazy load ToastContainer component
const ToastContainer = lazy(() =>
  import('react-toastify').then(module => ({
    default: () => <module.ToastContainer autoClose={3000} theme="colored" />,
  })),
);

export const LazyToastContainer = () => (
  <Suspense fallback={null}>
    <ToastContainer />
  </Suspense>
);

